export default "__VITE_ASSET__64201edf__"